"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBarChartOptions = void 0;

var _constants = require("./constants");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var adaptSeriesForArea = function adaptSeriesForArea(data, labels) {
  var seriesDivided = [{
    data: [],
    name: labels.bottomLabel
  }, {
    data: [],
    name: labels.topLabel
  }, {
    data: [],
    name: labels.middleLabel
  }, {
    data: [],
    name: labels.middleLabel
  }];

  if (!data || data.length === 0) {
    return seriesDivided;
  }

  data[0].data.forEach(function (_ref) {
    var x = _ref.x,
        low = _ref.low,
        high = _ref.high;
    var middle = data[2].data.find(function (item) {
      return item.x === x;
    });
    var middleRange = data[1].data.find(function (item) {
      return item.x === x;
    });
    seriesDivided[0].data.push({
      x: x,
      y: low,
      high: low,
      low: middleRange.high
    });
    seriesDivided[1].data.push({
      x: x,
      y: high,
      high: high,
      low: middleRange.low
    });
    seriesDivided[2].data.push({
      x: x,
      y: middle.y,
      high: middle.y,
      low: middleRange.low
    });
    seriesDivided[3].data.push({
      x: x,
      y: middle.y,
      high: middle.y,
      low: middleRange.high
    });
  });
  return [].concat(seriesDivided).map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      type: 'area',
      data: item.data.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          y: i.y || i.low
        });
      })
    });
  });
};

var getBarChartOptions = function getBarChartOptions(min, max, data, dataExternal, height, yAxisFormat, tooltipFormat, labels) {
  var areaData = adaptSeriesForArea(data, labels);
  var series = [].concat(_toConsumableArray(areaData), _toConsumableArray(dataExternal));
  var values = data.map(function (item) {
    return item.data;
  }).flat().map(function (_ref2) {
    var x = _ref2.x;
    return x;
  });
  var valuesY = areaData.map(function (item) {
    return item.data;
  }).flat().map(function (_ref3) {
    var y = _ref3.y;
    return y;
  });
  var valuesYExternal = dataExternal.map(function (item) {
    return item.data;
  }).flat().map(function (item) {
    return item[1];
  });
  var xMin = Math.min.apply(Math, _toConsumableArray(values));
  var xMax = Math.max.apply(Math, _toConsumableArray(values));
  var yMin = Math.min.apply(Math, _toConsumableArray(valuesY));
  var yMax = Math.max.apply(Math, _toConsumableArray(valuesY));
  var yExternalMin = Math.min.apply(Math, _toConsumableArray(valuesYExternal));
  var yExternalMax = Math.max.apply(Math, _toConsumableArray(valuesYExternal));

  var tickPositioner = function tickPositioner() {
    var TICKS_MAX_COUNT = 18;
    var positions = values.length ? [new Date(xMin).valueOf()] : [];
    var tick = xMin;
    var minYear = new Date(xMin).getFullYear();

    while (tick < xMax) {
      minYear += 1;
      tick = new Date(xMin).setFullYear(minYear).valueOf();
      positions.push(tick);
    }

    if (positions.length <= TICKS_MAX_COUNT) return positions;
    var delta = Math.ceil(positions.length / TICKS_MAX_COUNT);
    var selected = [];

    for (var i = 0; i < positions.length; i += delta) {
      selected.push(positions[i]);
    }

    return selected;
  };

  var yAxisMin = min || Math.min(yMin, yExternalMin);
  var yAxisMax = max || Math.max(yMax, yExternalMax);

  function yAxisFormatter() {
    if (!this) return null;
    if (this.value <= min) return yAxisFormat(this.value);
    if (this.value >= max) return yAxisFormat(this.value);
    return yAxisFormat(this.value);
  }

  function tooltipFormatter() {
    return "".concat(tooltipFormat(this));
  }

  function positioner(labelWidth, labelHeight, point) {
    return {
      x: point.plotX + this.chart.plotLeft - 0.5 * labelWidth,
      y: point.plotY - labelHeight - 11
    };
  }

  return _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions), {}, {
    chart: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.chart), {}, {
      height: height
    }),
    tooltip: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.tooltip), {}, {
      formatter: tooltipFormatter,
      positioner: positioner
    }),
    xAxis: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.xAxis), {}, {
      tickPositioner: tickPositioner,
      labels: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.xAxis.labels), {}, {
        formatter: function formatter() {
          if (!this) return '';
          var isFirst = this.isFirst,
              value = this.value;
          if (isFirst) return "<b>".concat(labels.yearsText, "</b>");
          var yearOffset = new Date(value).getFullYear() - new Date().getFullYear();
          return "+".concat(yearOffset);
        }
      })
    }),
    yAxis: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.yAxis), {}, {
      min: yAxisMin,
      max: yAxisMax,
      title: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.yAxis.title), {}, {
        text: labels.yTitle
      }),
      labels: _objectSpread(_objectSpread({}, _constants.defaultProjectionChartOptions.yAxis.labels), {}, {
        formatter: yAxisFormatter
      })
    }),
    series: series
  });
};

exports.getBarChartOptions = getBarChartOptions;